import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from 'src/components';
import Pagination from './Pagination';

const ClientListTable = ({ styles, searchResult, isSearching }) => {
  const PAGE_SIZE = 15;
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(
    () => {
      const firstPageIndex = (currentPage - 1) * PAGE_SIZE;
      const lastPageIndex = firstPageIndex + PAGE_SIZE;
      return searchResult.slice(firstPageIndex, lastPageIndex);
    },
    [currentPage, searchResult]
  );

  return (
    <div className="custom-feature-table">
      <div className={styles.clientListTable}>
        {isSearching ? (
          <Loading />
        ) : (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th>{t('features.ClientCustomFeatures.ClientList.table.identification')}</th>
                  <th>{t('features.ClientCustomFeatures.ClientList.table.company_name')}</th>
                  <th>{t('features.ClientCustomFeatures.ClientList.table.features')}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {currentTableData.length > 0 ? (
                  currentTableData.map(client => (
                    <tr key={`client-${client.id + 1}`}>
                      <td>{client.id}</td>
                      <td>{client.name}</td>
                      <td>
                        <ol>
                          {client.customFeatures.map(feature => (
                            <li key={`features-${feature.id + 1}`}>{feature.nameEn}</li>
                          ))}
                        </ol>
                      </td>
                      <td width="50px">
                        <a className="btn btn-primary" href={`/desk/client_custom_features/client/${client.id}`}>
                          {t('features.ClientCustomFeatures.ClientList.button.edit')}
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>No client list</td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              items={searchResult}
              pageSize={PAGE_SIZE}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              totalCount={searchResult.length}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ClientListTable;
